import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
      <footer class="footer mt-auto py-3">
          <div class="container">
              <span class="text-muted">Copyright © developed by Simone Testa.</span>
              <a href="https://www.iubenda.com/privacy-policy/57380404" class="float-right" target="_blank">Privacy Policy</a>
          </div>
      </footer>
  `,
  styles: []
})
export class FooterComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
